var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 30.9V22c4.7-.8 8.3-8 8.3-17.1 0-.5-.4-.9-.9-.9H11.9c-.5 0-.9.4-.9.9 0 9 3.6 16.2 8.3 17.1v9c-2.1.3-3.8 2.1-3.8 4.1 0 .5.4.9.9.9h7.5c.5 0 .9-.4.9-.9 0-2.1-1.7-3.8-3.8-4.2zm-6.1-18.4h-1.2c-.2-.5-.3-1.2-.5-1.8h2.4c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-2.8c-.1-1-.2-2.1-.3-3.2h7.9l.7 2.3-1.9 2.3c-.2.2-.3.5-.2.8l1.2 4.1c.2.5.5.7 1.1.6.5-.1.7-.6.6-1.1l-1-3.7 2-2.3c.2-.2.3-.5.2-.8l-.7-2.2h4.9c-.2 7.9-3.5 14.4-7.4 14.4-2.3 0-4.4-2.4-5.8-6h.5c.5 0 .9-.4.9-.9s-.2-.7-.6-.7zm5.3 20.1c1.2 0 2.2.6 2.6 1.6h-5.3c.4-.9 1.4-1.6 2.7-1.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragile);
export default __webpack_public_path__ + "static/media/fragile.a892d3d3.svg";
export { ForwardRef as ReactComponent };